import urlHelper from "@jmc/solid-design-system/src/utils/url-helper";

interface Props {
    url: string;
    locale: string;
    external?: boolean;
}
export const determineUrl = ({ url, locale = "en-us", external = false }: Props): string => {
    const mailToUrl = url?.includes("mailto:");
    const phoneNumberUrl = url?.startsWith("tel:");

    if (mailToUrl) {
        let subString = url.split(":").pop().split("@")[0];
        subString = url.replace(new RegExp(subString, "g"), "email");
        if (subString.includes("?")) subString = subString.slice(0, subString.indexOf("?"));
        return subString;
    }
    if (phoneNumberUrl) {
        return `callto phone-number`;
    }
    return external ? url : urlHelper.getFullUrl(url, locale, external);
};
